const AUTHENTICATED_SESSION_MARKER_KEY = 'issen_authenticated_session_v1'

type AuthenticationFailureHandler = () => void

let authenticationFailureHandler: AuthenticationFailureHandler | null = null
let authenticationFailureDispatched = false
let authenticatedInMemory = false

function localStorageOrNull(): Storage | null {
  if (typeof window === 'undefined') {
    return null
  }
  try {
    return window.localStorage
  } catch {
    return null
  }
}

export function markAuthenticatedSession(): void {
  authenticationFailureDispatched = false
  authenticatedInMemory = true
  const storage = localStorageOrNull()
  try {
    storage?.setItem(AUTHENTICATED_SESSION_MARKER_KEY, '1')
  } catch {
    // The in-memory marker still permits the current page to recover.
  }
}

export function clearAuthenticatedSession(): void {
  authenticatedInMemory = false
  const storage = localStorageOrNull()
  try {
    storage?.removeItem(AUTHENTICATED_SESSION_MARKER_KEY)
  } catch {
    // A stale non-secret marker is harmless; the one-shot guard still applies.
  }
}

export function consumeAuthenticationFailure(): boolean {
  if (authenticationFailureDispatched) {
    return false
  }
  const storage = localStorageOrNull()
  let hadAuthenticatedSession = authenticatedInMemory
  try {
    hadAuthenticatedSession =
      hadAuthenticatedSession ||
      storage?.getItem(AUTHENTICATED_SESSION_MARKER_KEY) === '1'
  } catch {
    // Retain the in-memory authenticated state.
  }
  if (!hadAuthenticatedSession) {
    return false
  }
  authenticationFailureDispatched = true
  clearAuthenticatedSession()
  return true
}

export function setAuthenticationFailureHandler(
  handler: AuthenticationFailureHandler | null,
): void {
  authenticationFailureHandler = handler
}

export function notifyAuthenticationFailure(): void {
  authenticationFailureHandler?.()
}
